import EN from 'assets/images/flags/us.svg';
import DE from 'assets/images/flags/de.svg';
import FR from 'assets/images/flags/fr.svg';
import ES from 'assets/images/flags/es.svg';
import JP from 'assets/images/flags/jp.svg';

const langs = {
  EN,
  DE,
  FR,
  ES,
  JP,
};

export default langs;
